export const SITE_URL = "https://economus.lt";

export const setMetaTag = (name: string, content: string) => {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  }
};

export const setCanonicalUrl = (path = "/") => {
  const href = `${SITE_URL}${path}`;
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (element) {
    element.href = href;
  } else {
    element = document.createElement("link");
    element.rel = "canonical";
    element.href = href;
    document.head.appendChild(element);
  }
};

export const setJsonLd = (id: string, data: Record<string, any>) => {
  const scriptId = `json-ld-${id}`;
  let element = document.getElementById(scriptId) as HTMLScriptElement | null;
  if (!element) {
    element = document.createElement("script");
    element.id = scriptId;
    element.type = "application/ld+json";
    document.head.appendChild(element);
  }
  element.textContent = JSON.stringify(data);
};

export const setPropertyMetaTag = (property: string, content: string) => {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (element) {
    element.setAttribute("content", content);
  } else {
    const meta = document.createElement("meta");
    meta.setAttribute("property", property);
    meta.content = content;
    document.head.appendChild(meta);
  }
};
